function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDisabled = function SvgDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 210 210"
  }, props), /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.153,
    cy: 105.356,
    stroke: "currentColor",
    rx: 93.003,
    ry: 92.799,
    style: {
      fill: "none",
      strokeWidth: 23.0518,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.449-24.967h163.823V2.579H66.449z",
    style: {
      fill: "currentColor",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.65592 .75483 -.73357 .67962 0 0)"
  }));
};
export default SvgDisabled;